import { getAdditionalEnrollmentStatuses } from 'utils/enrollmentStatuses';
import React from 'react';

import { Box, Button, useToast, Select } from '@chakra-ui/react';
import xhr from 'xhr';
import useAuth from 'hooks/useAuth';
import {
  canSetEnrollmentGraduated,
  isEnrollmentGraduatedForbidden,
  isEnrollmentStatusLocked,
  withEnrollmentStatusForUpdate,
} from 'utils/enrollmentGraduatedAccess';

export default function UpdateGrade(props) {
  const {
    statusEnrollment,
    setStatusEnrollment,
    groupEnrollment,
    setGroupEnrollment,
    semesterEnrollment,
    setSemesterEnrollment,
    gradeEnrollment,
    currentEnrollment,
    setCurrentEnrollment,
    id_est,
    dataAll,
    enrollments,
    semester,
    mutate,
  } = props;

  const [loading, setLoading] = React.useState(false);
  const [classGroups, setClassGroups] = React.useState([]);
  const toasts = useToast();
  const { user } = useAuth();
  const canSetGraduated = canSetEnrollmentGraduated(user);
  const statusLocked = isEnrollmentStatusLocked(user, currentEnrollment.status);
  React.useEffect(() => {
    const getGroups = async () => {
      try {
        const res = await xhr(
          `/class-groups?filters[grade][id][$eq]=${currentEnrollment.grade.id}&pagination[limit]=-1&populate=*`
        );

        setClassGroups(res.data.data);
      } catch (error) {}
    };
    getGroups();
  }, [currentEnrollment.id]);

  const updateState = async () => {
    try {
      if (!statusEnrollment || !semesterEnrollment || !groupEnrollment) {
        return window.alert('Debes llenar todos los campos');
      }

      setLoading(true);

      const resUpdate = await xhr.put(`/grade-enrollments/${currentEnrollment.id}`, {
        data: withEnrollmentStatusForUpdate({
          user,
          statusEnrollment,
          currentStatus: currentEnrollment.status,
          data: { semester: semesterEnrollment },
        }),
      });

      const classGroup = classGroups.find((el) => {
        return Number(el.id) === Number(groupEnrollment);
      });

      let studentGroup = currentEnrollment.student_group;
      if (classGroup && Number(groupEnrollment) !== Number(currentEnrollment.class_group?.id)) {
        if (currentEnrollment.student_group?.id) {
          await xhr.delete(`/student-groups/${currentEnrollment.student_group.id}`);
        }

        const studentGroupResponse = await xhr.post('/student-groups', {
          data: {
            student: id_est,
            class_group: groupEnrollment,
          },
        });

        const resN = await xhr(`/student-groups/${studentGroupResponse.data.data.id}?populate=*`);

        studentGroup = resN.data.data;

      }

      setCurrentEnrollment({
        ...currentEnrollment,
        ...resUpdate.data.data,
        class_group: studentGroup?.class_group || currentEnrollment.class_group,
        student_group: studentGroup,
      });

      mutate(
        {
          ...dataAll,
          enrollments: enrollments.map((el) => {
            if (el.id === currentEnrollment.id) {
              return {
                ...el,
                ...resUpdate.data.data,
                class_group: studentGroup?.class_group || currentEnrollment.class_group,
                student_group: studentGroup,
              };
            }

            return el;
          }),
        },
        { revalidate: false }
      );

      toasts({
        title: 'El enrollment se actualizó correctamente!',
        accent: 'bottom',
      });
    } catch (error) {
      console.error(error);
      if (isEnrollmentGraduatedForbidden(error)) {
        toasts({
          title: 'Solo Supervisor Admin puede marcar como graduado',
          status: 'error',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box>
        <Box>
          <Box fontWeight="bold" fontSize="20px">
            Modificar {currentEnrollment.grade.name}
          </Box>
          <hr />

          <Select
            value={statusEnrollment}
            marginTop="20px"
            name="estado_enrollment"
            label="Estado"
            color="black"
            placeholder="Estado"
            isDisabled={statusLocked}
            onChange={(e) => setStatusEnrollment(e.target.value)}
          >
            <option value="registrado">registrado</option>
            <option value="estudiando">estudiando</option>
            <option value="promovido">promovido</option>
            {(canSetGraduated || currentEnrollment.status === 'graduado') && (
              <option value="graduado">graduado</option>
            )}
            <option value="retirado">retirado</option>
            {getAdditionalEnrollmentStatuses('grade').map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </Select>

          <Select
            value={semesterEnrollment}
            marginTop="20px"
            name="semester_enrollment"
            label="Semestre"
            color="black"
            onChange={(e) => setSemesterEnrollment(e.target.value)}
          >
            {semester.map((el) => (
              <option value={el.value}>{el.label}</option>
            ))}
          </Select>
          <Box mt="10px">Grupos</Box>
          <Select
            value={groupEnrollment}
            marginTop="5px"
            name="group_enrollment"
            color="black"
            placeholder="Grupo"
            onChange={(e) => setGroupEnrollment(Number(e.target.value))}
            options={classGroups}
          >
            {classGroups.map((el) => (
              <option value={el.id}>{el.name}</option>
            ))}
          </Select>
        </Box>
        <br />
        <Button
          type="submit"
          colorScheme="#574feb"
          backgroundColor="#574feb"
          marginTop="15px"
          width="100%"
          isLoading={loading}
          onClick={updateState}
        >
          Actualizar
        </Button>
      </Box>
    </>
  );
}
